export const OWN_MATERIALS_TRANSITION_RELEASE_DATE = new Date(
  '2026-05-20T05:00:00Z',
);
